const TIPOS_WHATSAPP = ["whatsapp", "relatorio-whatsapp", "vendaonline-whatsapp"];

const TIPOS_PUBLICAVEIS_DOURASAT = ["whatsapp", "vendaonline-whatsapp"];

export const TEMPLATES_VENDA_ONLINE = {
  vendaonline: "Venda Online – link (e-mail)",
  "vendaonline-whatsapp": "Venda Online – link (WhatsApp)"
};

export const isTemplateWhatsapp = (tipo) => TIPOS_WHATSAPP.includes(tipo);

export const isTemplatePublicavelDourasat = (tipo) => TIPOS_PUBLICAVEIS_DOURASAT.includes(tipo);
